const SWITCH_START = '#SWITCH';
const SWITCH_END = '#ENDSWITCH';
const IF_START = '#IF';
const IF_END = '#ENDIF';
const SCRIPT_START_BEFORE = '<p>';
const SCRIPT_END_AFTER = '</p>';

export const indexes = (source, find) => {
  if (!source) {
    return [];
  }

  if (!find) {
    return source.split('').map((_, i) => i);
  }
  const result = [];

  for (let i = 0; i < source.length; ++i) {
    if (source.substring(i, i + find.length) === find) {
      result.push(i);
    }
  }

  return result;
};

export const addStr = (str, index, stringToAdd) =>
  str.substring(0, index) + stringToAdd + str.substring(index, str.length);

const getStrWoScript = (val, startIndex, endIndex) => {
  return (
    val.substring(0, startIndex + SCRIPT_END_AFTER.length) +
    val.substring(endIndex + 1, val.length)
  );
};

const getStrIndexes = (start, end, charsDiff) => {
  const startDetermined = start + charsDiff;
  const startIndex =
    startDetermined - SCRIPT_START_BEFORE.length <= 0
      ? 0
      : startDetermined - SCRIPT_START_BEFORE.length;
  const endIndex =
    end + charsDiff + SWITCH_END.length + SCRIPT_END_AFTER.length;

  return { startDetermined, startIndex, endIndex };
};

const reduceScriptString = ({ val, charsDiff }, { start, end }) => {
  const { startDetermined, startIndex, endIndex } = getStrIndexes(
    start,
    end,
    charsDiff
  );

  const scriptStr = val.substring(startDetermined, endIndex);
  const woScriptStr = getStrWoScript(val, startIndex, endIndex);

  const scriptStrReplace = scriptStr
    .replaceAll('<p>', '\n')
    .replaceAll('\n<h1>', '<h1temp>')
    .replaceAll('\n<h2>', '<h2temp>')
    .replaceAll('\n<h3>', '<h3temp>')
    .replaceAll('\n<h4>', '<h4temp>')
    .replaceAll('\n<h5>', '<h5temp>')
    .replaceAll('\n<h6>', '<h6temp>')
    .replaceAll('<h1>', '\n<h1>')
    .replaceAll('<h2>', '\n<h2>')
    .replaceAll('<h3>', '\n<h3>')
    .replaceAll('<h1temp>', '\n<h1>')
    .replaceAll('<h2temp>', '\n<h2>')
    .replaceAll('<h3temp>', '\n<h3>')
    .replaceAll('<h4temp>', '\n<h4>')
    .replaceAll('<h5temp>', '\n<h5>')
    .replaceAll('<h6temp>', '\n<h6>')
    .replaceAll('</p>', '')
    .replaceAll('<br>', '');

  const newVal = addStr(
    woScriptStr,
    startIndex + SCRIPT_START_BEFORE.length,
    scriptStrReplace
  );

  const lengDiff = scriptStr.length - scriptStrReplace.length;

  return { charsDiff: charsDiff - lengDiff, val: newVal };
};

const getPairs = (acc, val, i, arr) => {
  if (i % 2 !== 0) return acc;

  if (arr.length - 1 === i) return acc;

  return [...acc, { start: val, end: arr[i + 1] }];
};

const getScriptTxt = (txt, startStr, endStr) => {
  const getStrInd = (str) => indexes(txt, str);
  const startContentIndexes = getStrInd(`${SCRIPT_START_BEFORE}${startStr}`);
  const endContentIndexes = getStrInd(`${endStr}${SCRIPT_END_AFTER}`);

  const decoratedTxt = [...startContentIndexes, ...endContentIndexes]
    .sort((a, b) => a - b)
    .reduce(getPairs, [])
    .reduce(reduceScriptString, { charsDiff: 0, val: txt })
    .val.replaceAll(`</p>\n${startStr}`, `\n${startStr}`)
    .replaceAll(`${endStr}<p>`, `${endStr}\n`);

  return decoratedTxt;
};

export const getScriptsTxt = (txt) => {
  const cleanTxt = txt ? txt.replaceAll('\n', '') : '';

  const switchDecoratedTxt = getScriptTxt(cleanTxt, SWITCH_START, SWITCH_END);
  const ifDecoratedTxt = getScriptTxt(switchDecoratedTxt, IF_START, IF_END);

  return ifDecoratedTxt;
};
